/**
 * @author: leroy
 * @date: 2021/8/28 14:37
 * @description：header
 */

import styles from '@/styles/layout/header.module.scss';
import { observer } from 'mobx-react-lite';

import { useStore } from '@/store/store';
import Url from '@/utils/url';
import { Dropdown, Popover } from 'antd';
import React, { FC, CSSProperties, ReactNode } from 'react';
import { useState } from 'react';
import Cookies from 'js-cookie';
import { CaretDownOutlined } from '@ant-design/icons';
import { handleUrl } from '@/utils/util';
import classNames from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import { useRouter } from 'next/router';
import { provincialTalentExams } from '@/utils/consts';

const isProd = process.env.PROD;
// const year = new Date().getFullYear();

const Header: FC<{ mode: API.Common.Mode; isCeping?: boolean }> = ({ mode, isCeping = false }) => {
  const { userStore, homeStore, examStore, evalutionStore, monitorStore } = useStore();
  const router = useRouter();
  const [qrCodeVisible, setQrCodeVisible] = useState(true);
  const isEnterprise = homeStore.examLogoConfig?.is_enterprise_logo;

  const handleMenu = ({ key }) => {
    switch (key) {
      case 'login':
        console.log('登录');
        userStore.setConfirmModalShow(true);
        break;
      case 'logout':
        console.log('退出登录');
        Cookies.remove('exam_auth', { domain: '.haitou.cc' });
        Cookies.remove('haitou_user', { domain: '.haitou.cc' });
        Cookies.remove('haitou_uid', { domain: '.haitou.cc' });
        Cookies.remove('haitou_session', { domain: '.haitou.cc' });
        window.location.reload();
        break;
    }
  };

  const headerConfig: {
    logoConfig: { styles: CSSProperties | undefined; url: string };
    headerItems: ReactNode;
    dropdown: ReactNode;
  } = isEnterprise
    ? {
        logoConfig: { styles: undefined, url: handleUrl(homeStore.examLogoConfig.systemLogo) },
        headerItems: <></>,
        dropdown: <></>,
      }
    : {
        logoConfig: { styles: undefined, url: handleUrl(Url.staticHost + '/svg/logo1.svg') },
        headerItems: (
          <>
            {[
              { key: 'www', label: '海投网首页', url: Url.wwwHost },
              { key: 'xyzp', label: '校招网申', url: Url.wwwHost?.replace('www', 'xyzp') },
              { key: 'xjh', label: '宣讲会', url: Url.wwwHost?.replace('www', 'xjh') },
              { key: 'yxj', label: '云宣讲', url: Url.wwwHost?.replace('www', 'live') },
              { key: 'jlcr', label: '简历超人', url: Url.wwwHost?.replace('www', 'jlcr') },
            ].map((item) => (
              <a
                key={item.key}
                className={styles.item}
                href={handleUrl(item.url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.label}
              </a>
            ))}
          </>
        ),
        dropdown: (
          <Dropdown
            arrow={true}
            menu={{
              items: [
                {
                  key: 'xyzp',
                  label: (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={Url.wwwHost?.replace('www', 'xyzp')}
                    >
                      校招
                    </a>
                  ),
                },
                {
                  key: 'xjh',
                  label: (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={Url.wwwHost?.replace('www', 'xjh')}
                    >
                      宣讲会
                    </a>
                  ),
                },
                {
                  key: 'yxj',
                  label: (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={Url.wwwHost?.replace('www', 'live')}
                    >
                      云宣讲
                    </a>
                  ),
                },
              ],
            }}
          >
            <div className={styles.info}>
              2024校园招聘
              <img
                alt=""
                className={styles.icon}
                src={`${Url.staticHost}/image/home/icon-pull-down.png`}
              />
            </div>
          </Dropdown>
        ),
      };

  if (isCeping) {
    headerConfig.logoConfig = {
      styles: undefined,
      url: handleUrl(Url.staticHost + '/image/home/ceping-logo-header.1.png'),
    };

    if (provincialTalentExams.includes(router.query.paper as string)) {
      headerConfig.logoConfig = {
        styles: { width: 180, height: 'auto' },
        url: 'https://cdn7.haitou.cc/exam/static/image/home/ceping-logo-header.113349.png',
      };
      headerConfig.headerItems = <></>;
      headerConfig.dropdown = <></>;
    }
  }

  if (mode === 1) {
    return (
      <header className={styles.headerBox}>
        {!homeStore.hideLogoId.includes(homeStore.examId!) && (
          <div className={`center-wrapper flex-center-ali ${styles.main2}`}>
            <h1 className={styles.logo + ' flex-center-ali'}>
              <a href="/">
                <img
                  style={headerConfig.logoConfig.styles}
                  src={headerConfig.logoConfig.url}
                  alt="logo"
                />
              </a>
            </h1>
            <div className={'flex-center-ali ' + styles.centerNav}>{headerConfig.headerItems}</div>
            <div className={`flex-center-ali ${styles.right}`}>
              {headerConfig.dropdown}
              <Dropdown
                arrow={true}
                menu={{
                  items: userStore.auth
                    ? [{ key: 'logout', label: '退出登录', onClick: handleMenu }]
                    : [{ key: 'login', label: '用户登录' }],

                  onClick: (e) => handleMenu({ key: e.key }),
                }}
              >
                <div className={styles.user}>
                  {userStore.auth ? (
                    <>
                      <img
                        className={styles.face}
                        src={
                          handleUrl(userStore.userInfo?.faceLargeFullUrl) ||
                          'https://cdn6.haitou.cc/default/user-face-male.png'
                        }
                        alt=""
                      />
                      {userStore.userInfo?.name || userStore.phone}
                    </>
                  ) : (
                    '未登录'
                  )}
                  <CaretDownOutlined className={styles.icon} />
                </div>
              </Dropdown>
            </div>
          </div>
        )}
      </header>
    );
  }
  return (
    <header className={styles.headerBox}>
      <div
        className={classNames(`center-wrapper`, `flex-center-ali`, styles.main1, {
          [styles.code_monitor]: examStore.isCodeMonitor,
        })}
      >
        {!homeStore.hideLogoId.includes(homeStore.examId!) && (
          <h1 className={styles.logo + ' flex-center-ali'}>
            <a style={{ cursor: 'pointer' }} href="/">
              <img
                style={headerConfig.logoConfig.styles}
                src={headerConfig.logoConfig.url}
                alt="logo"
              />
            </a>
          </h1>
        )}
        <div className={styles.exam_name}>
          {evalutionStore.examDetail?.name || homeStore?.examDetail?.name}
        </div>

        <div className={styles.right}>
          <div style={{ height: 24 }}>
            <span style={{ marginRight: 20 }}>{userStore?.phone}</span>
            <img
              src={`${Url.staticHost}/image/home/${
                ([true, 'pc', 'wechatOut'] as any[]).includes(monitorStore.data?.mobileDeviceStatus)
                  ? 'pcActive'
                  : 'pcOffline'
              }.png`}
              alt="pc"
            />
            <Popover
              open={qrCodeVisible && monitorStore.data.mobileDeviceStatus === 'wechatOut'}
              getPopupContainer={(e) => e.parentNode as HTMLDivElement}
              content={
                <div style={{ textAlign: 'center' }}>
                  <QRCodeSVG
                    value={
                      'https://' +
                      (isProd
                        ? 'exam.haitou.cc' + `?auth=${userStore.auth}&examId=${router.query.paper}`
                        : 'exam01.haitou.cc' +
                          `?auth=${userStore.auth}&examId=${router.query.paper}`)
                    }
                    size={60}
                  />
                  <p style={{ fontSize: 12 }}>检测到小程序已断连，请扫码重试</p>
                </div>
              }
            >
              <span className={styles.phone_icon} onClick={() => setQrCodeVisible((p) => !p)}>
                <img
                  style={{ margin: '0 20px' }}
                  src={`${Url.staticHost}/image/home/${
                    monitorStore.data.mobileDeviceStatus === true ? 'phoneActive' : 'phoneOffline'
                  }.png`}
                  alt="phone"
                />
                {monitorStore.data.mobileDeviceStatus === 'wechatOut' && (
                  <div className={styles.dot} />
                )}
              </span>
            </Popover>
          </div>
        </div>
      </div>
    </header>
  );
};

export default observer(Header);
